import { ReactElement } from "react";
import { JSONTree } from "react-json-tree";

import { JsonValue } from "_/types";

type JsonTreeProps = {
  /**
   * Arbitrary JSON data to render.
   */
  data: JsonValue;

  /**
   * Hide the root element of the JSON tree.
   */
  hideRoot?: boolean;

  /**
   * Sort the keys of the JSON objects, including nested objects.
   */
  sortObjectKeys?: boolean;
};

// See the following link for the available theme properties that can be styled:
// https://github.com/reduxjs/redux-devtools/blob/main/packages/react-json-tree/src/createStylingFromTheme.ts#L44
const THEME = {
  extend: "tomorrow",
  tree: { backgroundColor: "transparent", fontFamily: "monospace" },
};

/**
 * A generic JSON tree component that renders JSON data in a collapsible tree view.
 */
export const JsonTree = (props: JsonTreeProps): ReactElement => {
  return <JSONTree theme={THEME} {...props} />;
};
